import {
  getLanguageEnum,
  getServerDateFormat,
  getWebinarDateTimeFromSelectedSlot
} from '@nw/shared/utils';

interface CommonRequestPropertiesTypes {
  values: Record<string, any>;
}

export const generateCommonRequestProperties = ({
  values
}: CommonRequestPropertiesTypes) => {
  const {
    preferredLanguage,
    preferredLanguages,
    selectADateToBookASlot,
    languageEnum
  } = values;

  const languageValue = preferredLanguage || preferredLanguages;
  let preferredLanguageEnum = languageValue && getLanguageEnum(languageValue);

  if (languageEnum) {
    preferredLanguageEnum = languageEnum;
  }

  let segmentWebinarDateTime;

  if (selectADateToBookASlot) {
    segmentWebinarDateTime = getWebinarDateTimeFromSelectedSlot(
      selectADateToBookASlot,
      values['timeSlots'] as string
    );
  }

  return {
    selected_slot_language: preferredLanguageEnum,
    segmentDateTime: segmentWebinarDateTime,
    selected_webinar_slot_datetime:
      segmentWebinarDateTime &&
      getServerDateFormat(new Date(segmentWebinarDateTime)),
    ...values,
    tabsDetails: undefined
  };
};
